import Message from "../Message";
import MarkdownRenderer from "../MarkdownRenderer";
import React from "react";

export default function ValuePropIntro(props) {
    const {valueTitle: title, valueDescription: description} = props;

    return <div className="col-xl-8 offset-xl-2 text-center">
        <div className="block-contents">
            <div className="section-title">
                <h2 className="text-start wow fadeInLeft" data-wow-duration="1.1s">
                    <Message>{title}</Message>
                </h2>
            </div>
            <div className="doc-content">
                <MarkdownRenderer>{description}</MarkdownRenderer>
            </div>
        </div>
    </div>
}
